import { useEffect, useRef } from "react";

// Below the xl breakpoint the piece detail sits under the calendar: bring it
// into view when a piece is opened so the user does not have to scroll.
export const useScrollIntoViewOnNarrow = <T extends HTMLElement>(
  isReady: boolean,
) => {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (isReady && window.innerWidth < 1280) {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isReady]);
  return ref;
};
